/*
 * Native Possum — np-hero-carousel.js
 * Behaviour for sections/hp-hero-carousel.liquid (see its header).
 * Loaded where it used to be written inline, without defer, so it runs at the same
 * moment as before (it sets up what the section looks like on load).
 */
  (function () {
    'use strict';
    var hero = document.querySelector('[data-np-hero]');
    if (!hero || !hero.classList.contains('np-hero--multi')) return;

    var wrap = hero.querySelector('.np-hero__slides');
    var slides = hero.querySelectorAll('[data-np-hero-slide]');
    var dots = hero.querySelectorAll('[data-np-hero-dot]');
    var pause = hero.querySelector('[data-np-hero-pause]');
    var carouselWidth = window.matchMedia('(min-width: 991px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var current = 0;
    var timer = null;
    var paused = false;
    var focusInside = false;

    function show(index) {
      slides[current].classList.remove('is-active');
      slides[current].inert = true;
      dots[current].classList.remove('is-active');
      dots[current].removeAttribute('aria-current');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      slides[current].inert = false;
      dots[current].classList.add('is-active');
      dots[current].setAttribute('aria-current', 'true');
    }

    function canPlay() {
      return carouselWidth.matches && !reduce.matches && !paused && !focusInside && !document.hidden;
    }

    // Autoplay is silent; changes the shopper makes are announced.
    function sync() {
      clearInterval(timer);
      timer = null;
      if (canPlay()) timer = setInterval(function () { show(current + 1); }, 8000);
      wrap.setAttribute('aria-live', timer ? 'off' : 'polite');
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.getAttribute('data-np-hero-dot'), 10));
        sync();
      });
    });

    pause.addEventListener('click', function () {
      paused = !paused;
      pause.setAttribute('aria-label', paused ? 'Play carousel' : 'Pause carousel');
      pause.querySelector('[data-np-hero-icon="pause"]').hidden = paused;
      pause.querySelector('[data-np-hero-icon="play"]').hidden = !paused;
      sync();
    });

    hero.addEventListener('keydown', function (e) {
      if (!carouselWidth.matches || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
      e.preventDefault();
      show(current + (e.key === 'ArrowRight' ? 1 : -1));
    });

    hero.addEventListener('focusin', function () { focusInside = true; sync(); });
    hero.addEventListener('focusout', function (e) {
      if (hero.contains(e.relatedTarget)) return;
      focusInside = false;
      sync();
    });

    document.addEventListener('visibilitychange', sync);
    carouselWidth.addEventListener('change', sync);
    reduce.addEventListener('change', sync);
    sync();
  })();
